var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mt-4 mb-4 pr-5 pl-5 text-danger",domProps:{"textContent":_vm._s(_vm.$t('view_schedule'))}}),_c('vs-divider',{staticClass:"mt-2 mb-6"}),_c('div',{staticClass:"ml-5 mr-5"},[_c('shared-view-schedule')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }